// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2sBPz","header":"Messages_header__1W02u"};